// @flow
import { FormattedCurrency } from "../../../../../../components/FormattedCurrency/FormattedCurrency";

export * from "../data";

export const currencyFormatter = (value: string | number) => (
  <FormattedCurrency
    value={value}
    minimumFractionDigits={2}
    maximumFractionDigits={2}
    currency="EUR"
  />
);

// Data hard coded for now. Should come from backend.
export const rows = [
  {
    location_html: <span>Durban, South Africa</span>,
    days_on_market: null,
    cost: 88400.04,
    rental: 529.7,
    airbnb: 4966.67,
  },
  {
    location_html: <span>Lagos, Nigeria</span>,
    days_on_market: null,
    cost: 124144.38,
    rental: 938.32,
    airbnb: 5631.32,
  },
  {
    location_html: <span>Cairo, Egypt</span>,
    days_on_market: null,
    cost: 56495.39,
    rental: 362.89,
    airbnb: 2458.54,
  },
  {
    location_html: (
      <span>
        Reykjavik, Iceland
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 392290.13,
    rental: 2064,
    airbnb: 12024.28,
  },
  {
    location_html: <span>Johannesburg, South Africa</span>,
    days_on_market: null,
    cost: 148394.2,
    rental: 823.16,
    airbnb: 4454.65,
  },
  {
    location_html: <span>Santiago, Chile</span>,
    days_on_market: null,
    cost: 175640.59,
    rental: 795.89,
    airbnb: 5169.12,
  },
  {
    location_html: <span>Athens, Greece</span>,
    days_on_market: null,
    cost: 194185.84,
    rental: 502.85,
    airbnb: 4599.83,
  },
  {
    location_html: <span>Bangalore, India</span>,
    days_on_market: null,
    cost: 106553.24,
    rental: 398.51,
    airbnb: 2339.3,
  },
  {
    location_html: <span>Dubai, UAE</span>,
    days_on_market: null,
    cost: 679342.65,
    rental: 3628.81,
    airbnb: 14890.71,
  },
  {
    location_html: <span>Bucharest, Romania</span>,
    days_on_market: null,
    cost: 157966.38,
    rental: 601.41,
    airbnb: 3441,
  },
  {
    location_html: <span>Medellin, Colombia</span>,
    days_on_market: null,
    cost: 165035.75,
    rental: 487.88,
    airbnb: 3337.71,
  },
  {
    location_html: <span>Cape Town, South Africa</span>,
    days_on_market: null,
    cost: 237320.55,
    rental: 1156.69,
    airbnb: 4756.67,
  },
  {
    location_html: <span>Budapest, Hungary</span>,
    days_on_market: null,
    cost: 174499.22,
    rental: 718.75,
    airbnb: 3279.64,
  },
  {
    location_html: <span>Istanbul, Turkey</span>,
    days_on_market: null,
    cost: 206380.71,
    rental: 891.89,
    airbnb: 3672.58,
  },
  {
    location_html: <span>Washington D.C., USA</span>,
    days_on_market: null,
    cost: 747973.6,
    rental: 3418.33,
    airbnb: 11682.71,
  },
  {
    location_html: <span>Delhi, India</span>,
    days_on_market: null,
    cost: 166097.31,
    rental: 494.64,
    airbnb: 2544.7,
  },
  {
    location_html: <span>Dusseldorf, Germany</span>,
    days_on_market: null,
    cost: 559340.54,
    rental: 1508.9,
    airbnb: 8167.21,
  },
  {
    location_html: <span>Sofia, Bulgaria</span>,
    days_on_market: null,
    cost: 141951.05,
    rental: 588.88,
    airbnb: 2054.65,
  },
  {
    location_html: <span>Frankfurt am Main, Germany</span>,
    days_on_market: null,
    cost: 656863.94,
    rental: 1631.57,
    airbnb: 9232.5,
  },
  {
    location_html: <span>Montreal, Canada</span>,
    days_on_market: null,
    cost: 332048.28,
    rental: 1214.72,
    airbnb: 4512.96,
  },
  {
    location_html: <span>Bogota, Colombia</span>,
    days_on_market: null,
    cost: 219849.85,
    rental: 650.48,
    airbnb: 2922.16,
  },
  {
    location_html: <span>Buenos Aires, Argentina</span>,
    days_on_market: null,
    cost: 250914.87,
    rental: 899.48,
    airbnb: 3298.44,
  },
  {
    location_html: <span>Sydney, Australia</span>,
    days_on_market: null,
    cost: 949706.28,
    rental: 3010.56,
    airbnb: 11849.31,
  },
  {
    location_html: <span>Dublin, Ireland</span>,
    days_on_market: null,
    cost: 590473.86,
    rental: 2000.2,
    airbnb: 7047.18,
  },
  {
    location_html: <span>Perth, Australia</span>,
    days_on_market: null,
    cost: 526258.91,
    rental: 1842.52,
    airbnb: 6206.56,
  },
  {
    location_html: (
      <span>
        Hamburg, Germany
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 569782.51,
    rental: 1426.69,
    airbnb: 6692.08,
  },
  {
    location_html: <span>Jakarta, Indonesia</span>,
    days_on_market: null,
    cost: 189656.92,
    rental: 1223.58,
    airbnb: 2225.3,
  },
  {
    location_html: (
      <span>
        Amsterdam, Netherlands
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 775195.42,
    rental: 2325.73,
    airbnb: 8892.16,
  },
  {
    location_html: <span>Riga, Latvia</span>,
    days_on_market: null,
    cost: 196744.57,
    rental: 626.86,
    airbnb: 2184.6,
  },
  {
    location_html: <span>Munich, Germany</span>,
    days_on_market: null,
    cost: 830750.9,
    rental: 1815.42,
    airbnb: 9223.21,
  },
  {
    location_html: <span>Edinburgh, UK</span>,
    days_on_market: null,
    cost: 365512.07,
    rental: 1528.61,
    airbnb: 3936.28,
  },
  {
    location_html: <span>Sao Paulo, Brazil</span>,
    days_on_market: null,
    cost: 278771.02,
    rental: 998.31,
    airbnb: 2987.61,
  },
  {
    location_html: <span>Mexico City, Mexico</span>,
    days_on_market: null,
    cost: 223681.09,
    rental: 806.07,
    airbnb: 2324.31,
  },
  {
    location_html: <span>Prague, Czech Republic</span>,
    days_on_market: null,
    cost: 322473.58,
    rental: 986.52,
    airbnb: 3332,
  },
  {
    location_html: (
      <span>
        Barcelona, Spain
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 431025.97,
    rental: 1222.42,
    airbnb: 4358.49,
  },
  {
    location_html: <span>Warsaw, Poland</span>,
    days_on_market: null,
    cost: 247275.98,
    rental: 852.91,
    airbnb: 2494.95,
  },
  {
    location_html: <span>Brussels, Belgium</span>,
    days_on_market: null,
    cost: 352295.94,
    rental: 1410.54,
    airbnb: 3406.49,
  },
  {
    location_html: <span>Rio de Janeiro, Brazil</span>,
    days_on_market: null,
    cost: 345918.07,
    rental: 1218.79,
    airbnb: 3313.67,
  },
  {
    location_html: (
      <span>
        Berlin, Germany
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 471112.7,
    rental: 1286.19,
    airbnb: 4489.63,
  },
  {
    location_html: <span>Geneva, Switzerland</span>,
    days_on_market: null,
    cost: 1250336.64,
    rental: 3172.85,
    airbnb: 11731.5,
  },
  {
    location_html: <span>Auckland, New Zealand</span>,
    days_on_market: null,
    cost: 734303.45,
    rental: 1932.07,
    airbnb: 6795.38,
  },
  {
    location_html: <span>Copenhagen, Denmark</span>,
    days_on_market: null,
    cost: 637229.52,
    rental: 2427.36,
    airbnb: 5688.91,
  },
  {
    location_html: <span>Melbourne, Australia</span>,
    days_on_market: null,
    cost: 652283.35,
    rental: 2163.56,
    airbnb: 5587.05,
  },
  {
    location_html: <span>Kuala Lumpur, Malaysia</span>,
    days_on_market: null,
    cost: 183526.24,
    rental: 843.76,
    airbnb: 1559.38,
  },
  {
    location_html: <span>Zurich, Switzerland</span>,
    days_on_market: null,
    cost: 1264298.43,
    rental: 2997.18,
    airbnb: 10424.88,
  },
  {
    location_html: <span>Los Angeles, USA</span>,
    days_on_market: null,
    cost: 818338.01,
    rental: 2944.77,
    airbnb: 6687.56,
  },
  {
    location_html: <span>Stockholm, Sweden</span>,
    days_on_market: null,
    cost: 874395.98,
    rental: 2056.11,
    airbnb: 7048.37,
  },
  {
    location_html: <span>Hanoi, Vietnam</span>,
    days_on_market: null,
    cost: 250774.47,
    rental: 794.22,
    airbnb: 1992.06,
  },
  {
    location_html: <span>Chicago, USA</span>,
    days_on_market: null,
    cost: 441763.7,
    rental: 2560.78,
    airbnb: 3503.12,
  },
  {
    location_html: <span>Osaka, Japan</span>,
    days_on_market: null,
    cost: 440625.64,
    rental: 1224.58,
    airbnb: 3481.7,
  },
  {
    location_html: <span>Oslo, Norway</span>,
    days_on_market: null,
    cost: 693754.92,
    rental: 2069.03,
    airbnb: 5413.31,
  },
  {
    location_html: <span>Toronto, Canada</span>,
    days_on_market: null,
    cost: 576950.49,
    rental: 1942.19,
    airbnb: 4288.52,
  },
  {
    location_html: <span>Miami, USA</span>,
    days_on_market: null,
    cost: 911610.77,
    rental: 2918.47,
    airbnb: 6657.34,
  },
  {
    location_html: <span>Madrid, Spain</span>,
    days_on_market: null,
    cost: 556850.58,
    rental: 1432.64,
    airbnb: 4024.34,
  },
  {
    location_html: <span>Bangkok, Thailand</span>,
    days_on_market: null,
    cost: 342581.1,
    rental: 1169.15,
    airbnb: 2426.41,
  },
  {
    location_html: <span>Vienna, Austria</span>,
    days_on_market: null,
    cost: 602312.31,
    rental: 1413.93,
    airbnb: 4176.42,
  },
  {
    location_html: <span>Brisbane, Australia</span>,
    days_on_market: null,
    cost: 503017.24,
    rental: 1917.94,
    airbnb: 3399.83,
  },
  {
    location_html: <span>Lisbon, Portugal</span>,
    days_on_market: null,
    cost: 459716.47,
    rental: 1065.09,
    airbnb: 3099,
  },
  {
    location_html: <span>Tel Aviv, Israel</span>,
    days_on_market: null,
    cost: 1090778.79,
    rental: 1726.48,
    airbnb: 6907.71,
  },
  {
    location_html: <span>Helsinki, Finland</span>,
    days_on_market: null,
    cost: 719405.71,
    rental: 1894.63,
    airbnb: 4117.16,
  },
  {
    location_html: <span>Milan, Italy</span>,
    days_on_market: null,
    cost: 884102,
    rental: 1785.57,
    airbnb: 5058.93,
  },
  {
    location_html: <span>Singapore, Singapore</span>,
    days_on_market: null,
    cost: 1393274.1,
    rental: 3431.91,
    airbnb: 7841.39,
  },
  {
    location_html: <span>Moscow, Russia</span>,
    days_on_market: null,
    cost: 599070.15,
    rental: 1380.15,
    airbnb: 3371.03,
  },
  {
    location_html: (
      <span>
        New York City, USA
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 1546627.69,
    rental: 4882.95,
    airbnb: 8538.01,
  },
  {
    location_html: (
      <span>
        London, UK
        <sup>6</sup>
      </span>
    ),
    days_on_market: null,
    cost: 2014503.14,
    rental: 5024.07,
    airbnb: 10489.05,
  },
  {
    location_html: (
      <span>
        San Francisco, USA
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 1336475.91,
    rental: 5094.71,
    airbnb: 6556.19,
  },
  {
    location_html: <span>Shanghai, China</span>,
    days_on_market: null,
    cost: 1054192.09,
    rental: 1805.64,
    airbnb: 5126.76,
  },
  {
    location_html: <span>Vancouver, Canada</span>,
    days_on_market: null,
    cost: 810833.99,
    rental: 2380.18,
    airbnb: 3782.3,
  },
  {
    location_html: (
      <span>
        Paris, France
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 1140125.29,
    rental: 2253.24,
    airbnb: 5279.55,
  },
  {
    location_html: <span>Rome, Italy</span>,
    days_on_market: null,
    cost: 928552.82,
    rental: 1730.71,
    airbnb: 4251.87,
  },
  {
    location_html: <span>Seoul, South Korea</span>,
    days_on_market: null,
    cost: 989804.29,
    rental: 1946.64,
    airbnb: 4317.32,
  },
  {
    location_html: <span>Tokyo, Japan</span>,
    days_on_market: null,
    cost: 1444865.27,
    rental: 2403.32,
    airbnb: 5480.43,
  },
  {
    location_html: <span>Taipei, Taiwan</span>,
    days_on_market: null,
    cost: 979110.44,
    rental: 1413.37,
    airbnb: 3611.89,
  },
  {
    location_html: <span>Hong Kong, Hong Kong</span>,
    days_on_market: null,
    cost: 2253306.57,
    rental: 3943.14,
    airbnb: 4941.36,
  },
  {
    location_html: <span>Beijing, China</span>,
    days_on_market: null,
    cost: 1260213.34,
    rental: 1879.77,
    airbnb: 1764.53,
  },
];
